<template>
<div class="odr-calendar" :class="{'odr-calendar_bright': bright}">
    <div class="odr-calendar__header">
        <tooltip :disabled="!prevDisabled">
            <button slot="trigger"
                    type="button"
                    class="odr-calendar__header__button"
                    :disabled="prevDisabled"
                    :data-qa="dataQa ? 'prev.' + dataQa : null"
                    @click="switchDelta(-1)">
                <icon>keyboard_arrow_left</icon>
            </button>
            <span slot="content">
                {{ $trl('aw.no_available_dates') }}
            </span>
        </tooltip>
        <div class="odr-calendar__header__title">
            {{ viewingMonth }}
        </div>
        <tooltip :disabled="!nextDisabled">
            <button slot="trigger"
                    type="button"
                    class="odr-calendar__header__button"
                    :disabled="nextDisabled"
                    :data-qa="dataQa ? 'next.' + dataQa : null"
                    @click="switchDelta(1)">
                <icon>keyboard_arrow_right</icon>
            </button>
            <span slot="content">
                {{ $trl('aw.no_available_dates') }}
            </span>
        </tooltip>
    </div>

    <div>
        <div v-for="(weekDay, index) in weekDays"
             :key="weekDay+index"
             class="odr-calendar__day odr-calendar__day_name">
            {{ weekDay }}
        </div>

        <button v-for="day in calendarDays"
                :key="day.string"
                type="button"
                class="odr-calendar__day"
                :disabled="day.empty || day.disabled"
                :data-qa="dataQa ? day.string + '.' + dataQa : null"
                :class="{
                    'odr-calendar__day_available': !day.empty && !day.disabled && !(value && valueComplex.string && (day.string === valueComplex.string)),
                    'odr-calendar__day_empty': day.empty,
                    'odr-calendar__day_selected': value && valueComplex.string && (day.string === valueComplex.string),
                    'odr-calendar__day_today': day.string === today.string,
                    'odr-calendar__day_disabled': day.disabled}"
                @click="selectItem(day)">
            {{ day.day }}
        </button>
    </div>
</div>
</template>

<script>
import '@/scss/blocks/calendar.scss';

import {
    date2str,
    str2date,
    countMonths,
} from '@/utils/format';

function createComplex (date) {
    return {
        day: date.getDate(),
        month: date.getMonth(),
        year: date.getFullYear(),
        string: date2str(date),
    };
}

export default {
    props: ['dataQa', 'availableDates', 'noBefore', 'noAfter', 'value', 'bright', 'viewDate', 'title', 'from', 'to'],
    data () {
        let weekDays = Array(7).fill(true)
            .map((_, index) => date2str(new Date(1970, 0, 4 + this.$root.appConfig.firstWeekDay + index), '#day:1')); // 4th is the first Sunday on epoch

        return {
            today: createComplex(new Date()),
            weekDays,
            viewing: this.viewDate || date2str(new Date()),
        };
    },
    computed: {
        prevDisabled () {
            if (!this.noBefore) {
                return false;
            } else {
                return countMonths(this.noBefore) >= countMonths(this.viewing);
            }
        },
        nextDisabled () {
            if (!this.noAfter) {
                return false;
            } else {
                return countMonths(this.noAfter) <= countMonths(this.viewing);
            }
        },
        viewingComplex () {
            return this.viewing && createComplex(str2date(this.viewing));
        },
        valueComplex () {
            return this.value && createComplex(str2date(this.value));
        },
        viewingMonth () {
            return date2str(str2date(this.viewing), '#month %Y');
        },
        calendarDays () {
            let date = new Date(1970, 0, 1);
            date.setYear(this.viewingComplex.year);
            date.setMonth(this.viewingComplex.month);

            return Array(6 * 7).fill(true).map((value, index) => {
                if (date.getDay() - this.$root.appConfig.firstWeekDay > index || date.getMonth() !== this.viewingComplex.month) {
                    return {
                        empty: true,
                    };
                }
                let result = createComplex(date);
                if (this.availableDates) {
                    result.disabled = !this.availableDates.includes(result.string);
                }
                if (!result.disabled && this.from) {
                    result.disabled = str2date(this.from) > str2date(result.string);
                }
                if (!result.disabled && this.to) {
                    result.disabled = str2date(this.to) < str2date(result.string);
                }

                date.setDate(date.getDate() + 1);
                return result;
            });
        },
        daysRange () {
            return this.calendarDays.map(day => day.string).filter(date => date !== undefined);
        },
    },
    watch: {
        viewDate (newValue) {
            this.viewing = newValue;
        },
        calendarDays () {
            this.viewing = this.daysRange[0];
        },
        viewing () {
            this.$emit('showingDates', this.daysRange);
        },
    },
    mounted () {
        this.$emit('showingDates', this.daysRange);
    },
    methods: {
        selectItem (day) {
            if (day.disabled || day.empty) {
                return;
            }
            this.$emit('input', day.string);
        },
        switchDelta (delta) {
            let viewingDate = str2date(this.viewing);
            viewingDate.setDate(1);
            viewingDate.setMonth(viewingDate.getMonth() + delta);
            this.viewing = date2str(viewingDate);
        },
    },
    components: {
        tooltip: require('@clearwave/odoro-markup/lib/vue/tooltip.vue').default,
        icon: require('@clearwave/odoro-markup/lib/vue/icon.vue').default,
    },
};
</script>
